import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SearchBar = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    const handleSearch = () => {
        const trimmed = searchTerm.trim();

        if (!trimmed) {
            // toast.warning("Please enter a city or country name.");
            return;
        }

        navigate(`/packages?q=${encodeURIComponent(trimmed)}`);
    };

    return (
        <div
            className="container-fluid search-bar position-relative"
            style={{ top: '-50%', transform: 'translateY(-50%)' }}
        >
            <div className="container" style={{ maxWidth: '800px' }}>
                <div
                    className="position-relative rounded-pill w-100 mx-auto p-3"
                    style={{ background: 'rgb(43 96 171 / 79%)' }}
                >
                    <input
                        className="form-control border-0 rounded-pill w-100 py-3 ps-4 pe-5"
                        type="text"
                        placeholder="Eg: Thailand"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                    <button
                        type="button"
                        className="btn btn-primary rounded-pill py-2 px-4 position-absolute me-2"
                        style={{
                            top: '50%',
                            right: '15px',
                            transform: 'translateY(-50%)',
                        }}
                        onClick={handleSearch}
                    >
                        Search
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchBar;
